export default "__VITE_ASSET__7FYK93iP__"